var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteStoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27227 1.83923C3.01828 0.572476 2.02085 1.19175 1.49961 1.91778C1.32198 2.16519 1.2721 2.47497 1.28229 2.77937C1.3146 3.74504 1.30094 5.0701 1.15258 9.06118C1.01808 12.6792 2.59585 14.1618 3.88433 14.9001C4.47286 15.2374 4.90195 15.8087 4.9457 16.4856L5.15962 19.7958C5.22165 20.7555 6.01818 21.5023 6.97994 21.5023H15.7012C16.7086 21.5023 17.5237 20.6842 17.5983 19.6795C17.7013 18.2939 17.8665 17.2103 17.7724 16.5183C17.7501 16.3539 17.7257 16.1891 17.7167 16.0234C17.5726 13.3544 15.1177 13.0378 13.994 12.9778H10.0328H8.25031C5.44437 13.2611 4.79132 10.2359 4.63392 9.06118L4.68096 2.94579C4.6841 2.53775 4.55934 2.12923 4.27227 1.83923Z",
    stroke: "white",
    strokeWidth: 1.72092
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7909,
    cy: 6.82854,
    r: 3.64191,
    stroke: "white",
    strokeWidth: 1.72092
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStoryIcon);
export default __webpack_public_path__ + "static/media/whiteStoryIcon.2e7efc3c62b4ee92a75bb7242489f292.svg";
export { ForwardRef as ReactComponent };